import { Radio } from 'antd';
import { FC, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';

interface ITcSelectReduxSearch {
  value?: string | number | undefined | null;
  labelPropertyName?: string;
  prefixLabelPropertyName?: string;
  reducerName: string;
  reducerListProperty: string;
  getlist: any;
  onChange?: (_a: string | number) => void;
  onChangeFullInfo?: (_a: any) => void;
  underValue?: boolean;
  disabled?: boolean;
  wrapperClassName?: string;
  itemsClassName?: string;
  additionalItem?: any[];
}

const TcRadioReduxSearch: FC<ITcSelectReduxSearch> = ({
  value,
  reducerName,
  reducerListProperty,
  underValue,
  onChange,
  onChangeFullInfo,
  getlist,
  labelPropertyName = 'title',
  prefixLabelPropertyName,
  disabled,
  wrapperClassName,
  itemsClassName,
  additionalItem,
  ...props
}) => {
  //states
  const state = useSelector((state: any) => state[reducerName]);
  const optionsList = underValue ? state.value[reducerListProperty] : state[reducerListProperty];

  //effect
  useEffect(() => {
    !optionsList && store.dispatch(getlist());
  }, []);

  //functions
  const handleChange = (e: any) => {
    onChange && onChange(e);
    if (onChangeFullInfo) {
      const item = [...(optionsList || []), ...(additionalItem || [])]?.find((item: any) => item.id === e);
      onChangeFullInfo({ ...item, label: item.title, value: item.id });
    }
  };
  const getLabel = (item: any) => {
    const label = item[labelPropertyName];

    if (prefixLabelPropertyName) {
      const prefix = item[prefixLabelPropertyName];
      if (prefix) return prefix + ' - ' + label;
    }
    return label;
  };
  const options = useMemo(() => {
    const items: { label: string; value: any }[] = [];
    optionsList &&
      [...optionsList, ...(additionalItem || [])]?.map((item: any) => {
        items.push({ label: getLabel(item), value: item.id });
      });
    return items;
  }, [optionsList]);

  return (
    <div className={wrapperClassName ? wrapperClassName : 'flex gap-2'}>
      {options.map((item: any) => (
        <div
          key={item.value}
          className={`px-4 py-2 flex w-full items-center border rounded-md gap-2  text-sm   ${value === item.value && !disabled && 'border-t-primary-color'} ${
            disabled ? 'text-t-secondary-text-color cursor-not-allowed' : 'hover:border-t-primary-color cursor-pointer'
          } ${itemsClassName}`}
          onClick={() => {
            if (disabled) return;
            handleChange(item.value);
          }}>
          <Radio checked={value === item.value} disabled={disabled} {...props} />
          {item.label}
        </div>
      ))}
    </div>
  );
};

export default TcRadioReduxSearch;
